import { espaceDe } from './apparence';

/**
 * Une vidéo hébergée par Cabaza (fichier mp4 ou webm).
 *
 * UN LECTEUR NATIF, PAS UN LECTEUR TIERS : aucun cookie, aucune requête vers
 * un autre site, et le visiteur garde les commandes de son navigateur. Les
 * adresses sont déjà filtrées par le serveur (https: ou chemin interne).
 *
 * `alt` décrit la vidéo pour qui ne la voit pas ; `sousTitres` est un fichier
 * .vtt — sans lui, la vidéo n'est pas accessible aux sourds : le texte de
 * la voix off doit y figurer.
 *
 * Sans adresse, le bloc ne rend rien : une page en préparation n'affiche pas
 * de lecteur vide.
 */
const VideoBloc = ({ bloc, langue = 'fr' }) => {
    if (!bloc?.url) return null;

    return (
        <figure className={espaceDe(bloc.espace, 'mb-10')} data-testid="bloc-video">
            {bloc.titre && (
                <h2 className="text-xl font-bold text-gray-900 mb-3">{bloc.titre}</h2>
            )}
            <video
                className="w-full rounded-2xl bg-black"
                controls
                preload="metadata"
                playsInline
                poster={bloc.poster || undefined}
                aria-label={bloc.alt || bloc.titre || undefined}
            >
                <source src={bloc.url} />
                {bloc.sousTitres && (
                    <track kind="subtitles" src={bloc.sousTitres} srcLang={langue} label={langue.toUpperCase()} default />
                )}
            </video>
            {bloc.legende && (
                <figcaption className="text-sm text-gray-500 mt-2">{bloc.legende}</figcaption>
            )}
        </figure>
    );
};

export default VideoBloc;
